import React from 'react';
import { Car } from 'lucide-react';
import { formatDriveDuration, formatDriveDistance } from '@/utils/routeFormatting';
import type { UnitSystem } from '@/hooks/useUnitPreferences';

interface DriveTimeConnectorProps {
  duration: number | null; // seconds
  distance: number | null; // meters
  loading: boolean;
  units: UnitSystem;
}

export const DriveTimeConnector: React.FC<DriveTimeConnectorProps> = ({
  duration,
  distance,
  loading,
  units,
}) => {
  if (loading) {
    return (
      <div className="relative flex items-center gap-2 pl-[52px] py-1">
        <div className="h-4 w-32 bg-muted animate-pulse rounded" />
      </div>
    );
  }

  if (duration === null || distance === null) return null;

  return (
    <div className="relative flex items-center gap-1.5 pl-[52px] py-1 text-xs text-muted-foreground">
      <Car className="w-3.5 h-3.5 shrink-0" />
      <span>{formatDriveDuration(duration)}</span>
      <span className="text-border">·</span>
      <span>{formatDriveDistance(distance, units)}</span>
    </div>
  );
};
